import React from "react";
import {AlertTooltip} from "./base/AlertTooltip";

export class PeriodDatesCellTooltip extends AlertTooltip {
    render() {
        let specialDatesContent = this.specialDatesContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <div className="col-12 m-0 p-0"><p
                            className="alert-tooltip-title">FECHAS ESPECIALES<span></span>
                        </p></div>
                    </div>
                    {specialDatesContent}
                </div>
            </div>

        )
    }

    workOnDays() {
        return this.props.itemPeriodDates.itemScheduleConfiguration().workOnDays();
    }

    specialDatesContent() {
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    Días: <span style={{fontWeight:"bold"}}>{this.workOnDays().join(", ")}</span>
                </p>
            </div>
        );
    }
}
